/**
 * Created by jxm on 16-6-6.
 * 存放全局变量
 */
module.exports = {
  curRoute:{
    path:'',
    pathName:'',
    params:{},
    backpath:''
  },
  activationCode:'',
  signUserId:null,
  currentTab:1,
  app:0,
  isWKWebView:0,
  enterId:null,
  language:''
};


//////////////////
// WEBPACK FOOTER
// ./src/constant.js
// module id = 157
// module chunks = 5